import { Box, Typography } from '@mui/material'
import React from 'react'
import { ReactTyped } from 'react-typed'

const Placeholder = () => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      height={'100%'}
    >
      <Typography variant="h1" fontFamily="">
        <ReactTyped
          strings={[
            "Olá, eu sou o Christian!",
            "Bem-vindo(a) ao meu portfólio! 🙌🏼",
          ]}
          typeSpeed={50}
          backSpeed={30}
          loop
          showCursor
        />
      </Typography>
    </Box>
  )
}

export default Placeholder
